import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function MypageSideMenu() {
  const location = useLocation();

  const toHomeUrl = (path) => {
    try {
      const base = String(rmVars?.homeUrl || '').replace(/\/+$/, '');
      const p = String(path || '').replace(/^\/+/, '');
      return `${base}/${p}`;
    } catch (e) {
      return path || '/';
    }
  };

  const menuItems = {
    Profile: [
      { label: 'My Profile', icon: 'profile-myprofile.png', path: '/mypage/edit/profile', key: 'profile' },
      // { label: 'Change Password', icon: 'profile-chpw.png', path: '/mypage/edit/password', key: 'password' },
      { label: 'Researcher ID', icon: 'profile-researcherid.png', path: '/mypage/edit/researcher-id', key: 'researcher-id' },
      { label: 'Saved Researcher', icon: 'profile-savedresearcher-star.png', path: '/mypage/edit/saved-researcher', key: 'saved-researcher' },
      // { label: 'Publications', icon: 'profile-myresources.png', path: '/mypage/edit/publications', key: 'publications' },
    ],
    Setting: [
      { label: 'Notification', icon: 'setting-noti.png', path: '/mypage/edit/settings/notification', key: 'notification' },
      { label: '회원 탈퇴', icon: 'trash-ico.png', path: '/mypage/edit/settings/withdrawal', key: 'withdrawal' },
    ],
    Support: [
      { label: 'Help & Support', icon: 'support-help.png', path: '/mypage/edit/support/help', key: 'help' },
      // { label: 'Notice', icon: 'support-noti.png', path: '/mypage/edit/support/notice', key: 'notice' },
      // { label: 'FAQ', icon: 'support-faq.png', path: '/mypage/edit/support/faq', key: 'faq' },
    ],
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="mypage-left-menu mt-8">
      {/* Profile */}
      <div className="mb-3 pb-3 border-b border-b-[#E4E8F1]">
        <p className="mb-[10px] text-[12px] text-[#8D9AAF] leading-[100%] font-bold">Profile</p>
        <ul>
          {menuItems.Profile.map((item) => (
            <li
              key={item.key}
              className={`${isActive(item.path) ? 'active' : ''} relative h-10 px-3 rounded-[8px]`}
            >
              <Link to={item.path} className="flex gap-4 items-center w-full h-full">
                <img src={rmVars.themeUrl + 'images/' + item.icon} className="w-5" alt={item.label} />
                <span className="text-[14px] leading-[100%] font-medium text-[#6C7687]">{item.label}</span>
                <img
                  src={rmVars.themeUrl + 'images/chevron_right_6C7687.png'}
                  className="arr hidden absolute top-[50%] right-3 w-4 translate-y-[-50%] rotate-180"
                  alt="arr"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Setting */}
      <div className="mb-3 pb-3 border-b border-b-[#E4E8F1]">
        <p className="mb-[10px] text-[12px] text-[#8D9AAF] leading-[100%] font-bold">Setting</p>
        <ul>
          {menuItems.Setting.map((item) => (
            <li
              key={item.key}
              className={`${isActive(item.path) ? 'active' : ''} relative h-10 px-3 rounded-[8px]`}
            >
              <Link to={item.path} className="flex gap-4 items-center w-full h-full">
                <img src={rmVars.themeUrl + 'images/' + item.icon} className="w-5" alt={item.label} />
                <span className="text-[14px] leading-[100%] font-medium text-[#6C7687]">{item.label}</span>
                <img
                  src={rmVars.themeUrl + 'images/chevron_right_6C7687.png'}
                  className="arr hidden absolute top-[50%] right-3 w-4 translate-y-[-50%] rotate-180"
                  alt="arr"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Support */}
      <div>
        <p className="mb-[10px] text-[12px] text-[#8D9AAF] leading-[100%] font-bold">Support</p>
        <ul>
          {menuItems.Support.map((item) => (
            <li
              key={item.key}
              className={`${isActive(item.path) ? 'active' : ''} relative h-10 px-3 rounded-[8px]`}
            >
              {item.key === 'help' ? (
                <a href={toHomeUrl('/qna/')} className="flex gap-4 items-center w-full h-full">
                  <img src={rmVars.themeUrl + 'images/' + item.icon} className="w-5" alt={item.label} />
                  <span className="text-[14px] leading-[100%] font-medium text-[#6C7687]">{item.label}</span>
                  <img
                    src={rmVars.themeUrl + 'images/chevron_right_6C7687.png'}
                    className="arr hidden absolute top-[50%] right-3 w-4 translate-y-[-50%] rotate-180"
                    alt="arr"
                  />
                </a>
              ) : (
                <Link to={item.path} className="flex gap-4 items-center w-full h-full">
                  <img src={rmVars.themeUrl + 'images/' + item.icon} className="w-5" alt={item.label} />
                  <span className="text-[14px] leading-[100%] font-medium text-[#6C7687]">{item.label}</span>
                  <img
                    src={rmVars.themeUrl + 'images/chevron_right_6C7687.png'}
                    className="arr hidden absolute top-[50%] right-3 w-4 translate-y-[-50%] rotate-180"
                    alt="arr"
                  />
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
